// src/pages/SmokeWindow.jsx
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

function SmokeWindow() {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState('단창용');

  return (
    <div className="text-gray-800">
      {/* 배경 이미지 Hero 섹션 */}
      <section className="relative h-[60vh] bg-[url('hero-bg.jpg')] bg-cover bg-center flex items-center justify-center">
        <div className="absolute inset-0 bg-black bg-opacity-50" />
        <div className="relative z-10 text-center px-4 flex flex-col justify-center h-full">
          <h1 className="text-4xl md:text-5xl font-bold text-white">제품소개</h1>
          <p className="mt-4 text-white text-lg md:text-xl">JDWinTech의 대표 제품들을 소개합니다.</p>

          {/* 하단 탭 메뉴 */}
          <div className="absolute bottom-0 left-0 w-full bg-black bg-opacity-40 flex justify-center" style={{ bottom: 0 }}>
            <div className="flex">
              <Link
                to="/products/smoke"
                className={`rounded-tl-md px-6 py-3 text-sm md:text-base font-medium ${location.pathname === '/products/smoke' ? 'bg-white text-blue-800' : 'text-white hover:bg-white hover:text-blue-800'}`}
              >
                배연창
              </Link>
              <Link
                to="/products/vent"
                className={`px-6 py-3 text-sm md:text-base font-medium ${location.pathname === '/products/vent' ? 'bg-white text-blue-800' : 'text-white hover:bg-white hover:text-blue-800'}`}
              >
                환기창
              </Link>
              <Link
                to="/products/closer"
                className={`rounded-tr-md px-6 py-3 text-sm md:text-base font-medium ${location.pathname === '/products/closer' ? 'bg-white text-blue-800' : 'text-white hover:bg-white hover:text-blue-800'}`}
              >
                창문형 자동폐쇄장치
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* 제품 설명 섹션 */}
      <section className="py-20 px-4 md:px-20 max-w-6xl mx-auto">
        <h2 className="text-2xl font-bold text-blue-800 mb-6 text-center">배연창</h2>

        {/* 제품 타입 탭 */}
        <div className="inline-flex justify-center overflow-hidden rounded-md border border-gray-300 mb-10">
          {[
            '단창용',
            '90˚ 오픈창문용',
            '대형창문용',
            '대형창문용 PARALLEL창',
            '슬라이딩 단창용',
            '슬라이딩 이중창용'
          ].map((label, idx) => (
            <button
              key={label}
              onClick={() => setActiveTab(label)}
              className={`px-6 py-3 text-sm md:text-base font-medium min-w-[150px] text-gray-700 hover:bg-gray-100 focus:z-10 ${activeTab === label ? 'bg-indigo-800 text-white' : ''}`}
            >
              {label}
            </button>
          ))}
        </div>

        {['단창용', '90˚ 오픈창문용', '대형창문용', '대형창문용 PARALLEL창', '슬라이딩 단창용', '슬라이딩 이중창용'].map((label, idx) => (
          activeTab === label && (
            <div key={idx} className="mb-16">
              <img src={`/images/smoke/${idx + 1}.jpg`} alt={`${label} 이미지`} className="w-full max-w-3xl mx-auto mb-6 rounded shadow" />

              <div className="text-gray-700 leading-relaxed space-y-8 max-w-4xl mx-auto">
                <div>
                  <h3 className="text-2xl font-bold text-center mb-2">기능</h3>
                  <p className="text-center text-red-600 font-semibold mb-4">특허 등록 (제10-2175022호)</p>
                  <ul className="list-disc pl-5 space-y-2">
                    <li>화재 감지 신호 연동 시 즉시 자동 개방</li>
                    <li>평상시 환기 용도로 사용 가능 (리모컨/스위치 제어)</li>
                    <li>우천 시 감지 센서를 통한 자동 닫힘 기능 (옵션)</li>
                    <li>방범 기능 및 안전 사고 방지 시스템 적용</li>
                  </ul>
                </div>
                <div>
                  <img src="/product_sample_images/background.jpg" alt="도입배경" className="w-full rounded" />
                </div>
                <div>
                  <img src="/product_sample_images/benefit.jpg" alt="도입효과" className="w-full rounded" />
                </div>
                <div>
                  <img src="/product_sample_images/example.jpg" alt="설치사례" className="w-full rounded" />
                </div>
                <div>
                  <img src="/product_sample_images/usecase.jpg" alt="활용방안" className="w-full rounded" />
                </div>
              </div>
            </div>
          )
        ))}
      </section>
    </div>
  );
}

export default SmokeWindow;